


























































































































import {
  Vue, Prop, Component, Emit,
} from 'vue-property-decorator';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbTooltipSlot } from '@/shared/slots/tooltip-slot.component.vue';
import DateFormat from '@/shared/utils/date-format';
import moment from 'moment';
import RowComponent from './overview-contract-summary-row.component.vue';
import Header from './header.json';
import ContractStatus from '../contract/contract-datatable/contract-status.json'
import OverviewCardExpandableRow from './overview-main-card-expandable-row.component.vue';

@Component({
  filters: {
    toCurrency: VbDirectives.toCurrency,
  },
  components: { RowComponent, OverviewCardExpandableRow, VbTooltipSlot },
})
export default class OverviewMainCardTable extends Vue {
  @Prop({
    required: true,
  })
  private summary!: any[];

  @Prop({
    required: false,
    default: false,
  })
  private displayValue!: boolean;

  @Prop({
    type: Boolean,
  }) private loadingInstance!: boolean;

  @Prop({
    type: String,
  }) private selectedCompetence!: string;

  private headers: object[] = [...Header];

  @Emit('goToView')
  private goToView(status: string): string {
    return status;
  }

  created() {
    this.checkHeaders();
  }

  private checkHeaders(): void {
    if (this.displayValue) {
      const amount: object = this.headers.splice(1, 1)[0];
      this.headers.push(amount);
      this.headers.push(this.valueColumn);
    }
  }

  private get valueColumn(): object {
    return {
      text: 'VALOR R$',
      align: 'right',
      value: 'value',
      width: '33%',
      sortable: false,
    }
  }

  monthYear(value: string): string {
    const date: string = DateFormat.localDateToLocal(value);
    return DateFormat.fullMonthAndYear(date);
  }

  get getDefaultMonth() {
    return moment().locale('pt-BR').subtract(1, 'months').format('MMMM, YYYY');
  }

  get inactiveWithoutMessage(): string {
    return `Com instâncias inativas e com consumo (para competência: ${this.formattedCompetence})`
  }

  get atCompetenceLabel(): string {
    return `Na competência de ${this.formattedCompetence}`;
  }

  get formattedCompetence(): string {
    return this.selectedCompetence ? this.monthYear(this.selectedCompetence) : this.getDefaultMonth;
  }

  get atContractExpireInCompetenceLabel(): string {
    return `Com previsão de encerramento (para competência: ${this.formattedCompetence})`
  }

  getDescriptionItem(detail: string): string {
    const obj = ContractStatus.find((e: any) => e.value === detail);
    if (obj == null) {
      return 'Indefinido'
    }
    return obj.description;
  }

  getTooltipDescription(name: string) {
    const description = {
      Ativos: 'Todos os contratos que estão ativos no Billing e no ERP',
      Inativos: 'Todos os contratos que estão inativos no Billing e no ERP',
      Cancelados: 'Todos os contratos que estão cancelados apenas no Billing',
    }
    return description[name]
  }
}
